module.exports = __webpack_public_path__ + "static/media/destacados-3.958d5ea1.png";